import { useState, useEffect, useCallback } from "react";
import { useAuth } from "../auth/AuthProvider";
import i18n from "../i18n";

const API_URL = process.env.REACT_APP_API_URL;

/**
 * Fetches the user's profile from the backend (RDS).
 * Returns null while loading, and a profile object once loaded.
 * The profile object always has all fields (empty string if unset).
 * Also applies the user's saved language preference on load.
 */
export const useUserProfile = () => {
  const auth = useAuth();
  const [profile, setProfile] = useState(null);
  const token = auth.user?.access_token;

  const fetchProfile = useCallback(async () => {
    if (!token) return;
    try {
      const res = await fetch(`${API_URL}/user/profile`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        setProfile(data);
        if (data.language && data.language !== i18n.language) {
          i18n.changeLanguage(data.language);
        }
      }
    } catch {}
  }, [token]);

  useEffect(() => {
    if (auth.isAuthenticated) fetchProfile();
  }, [auth.isAuthenticated, fetchProfile]);

  return { profile, refetch: fetchProfile };
};
